import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { get_taxinvoiceList_action, download_taxinvoice_action } from "../../../actions/accounts_action/taxInvoice_action/taxInvoice_action";
import { downloadReport, responseError, role_id } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
import moment from "moment";
import Footer from "../../../common_components/Footer";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import MobileHeader from "../../../common_components/mobileHeader";

class TaxInvoiceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      user_id: "",
      taxinvoice_id: "",
      ApplicantName: "",
      Description: "",
      StatusID: "",
      taxinvoiceList: [],
      taxinvoiceDate: "",
      taxinvoiceInvoiceNo: "",
      Experience: "",
      isAccordionExpanded: false,
      currentPage: 1,
      application_no: ''
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem("AwardsUserLoginData") == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }

    setTimeout(() => {
      {
        sessionStorage.getItem("role_id") == 2 ? (
          this.props.navigate("/login")
        ) : <></>
      }
    }, 10);

    this.setState({
      user_id: sessionStorage.getItem("user_id") || "",
    });
    this.getTaxinvoiceList();
  }

  getTaxinvoiceList = () => {
    const { ApplicantName, taxinvoiceDate, taxinvoiceInvoiceNo, application_no } = this.state;
    this.setState({ isLoading: true });
    this.props.get_taxinvoiceList_action(
      ApplicantName != '' ? ApplicantName : null,
      taxinvoiceDate != '' ? moment(taxinvoiceDate).format('YYYY-MM-DD') : null,
      taxinvoiceInvoiceNo != '' ? taxinvoiceInvoiceNo : null,
      application_no != '' ? application_no : null,
    )
      .then((data) => {
        if (data.error !== 1) {
          this.setState({
            taxinvoiceList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          this.setState({ isLoading: false });
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  navigatetaxinvoiceAdd = () => {
    this.props.navigate("/juryProfileAU");
  }

  navigatetaxinvoiceUpdate = (taxinvoice_id) => {
    this.props.navigate(`/juryProfileAU`, {
      state: { taxinvoice_id: taxinvoice_id },
    });
  }

  clearFilters = () => {
    this.setState({
      ApplicantName: "",
      taxinvoiceDate: "",
      taxinvoiceInvoiceNo: "",
      application_no: ''
    }, () => {
      this.getTaxinvoiceList();
    });
  }

  updateItem = (item) => {
    this.setState({ currentPage: item });
  }

  viewtaxinvoice(application_form_id, taxinvoice_id) {
    this.setState({ isLoading: true })
    this.props
      .download_taxinvoice_action(application_form_id, taxinvoice_id)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false })
          // var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
          // var url = `${downloadReport}?SessionIdentifier=${data}`;
          // const win = window.location.replace(url, '_blank');
          const url = `${downloadReport}?SessionIdentifier=${data}`;
          window.open(url, "_blank", 'noopener,noreferrer');
        }
        else {
          this.setState({ isLoading: false })
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  taxinvoiceRecords(taxinvoiceList) {
    // const { userList } =this.state
    return (
      <table class="table table-bordered" id="dashboard-table">
        <thead>
          <tr >
            <th className="text-left"> Application No</th>
            <th className="text-left"> taxinvoice No</th>
           <th style={{ width: "18%" }}>Applicant Name</th>
           <th style={{ width: "18%" }}>Company Name</th>
            <th className="text-center">taxinvoice Date</th>
            <th className="text-center">Taxable Amount</th>
            <th className="text-center">CGST</th>
            <th className="text-center">SGST</th>
            <th className="text-center">IGST</th>
            <th className="text-center">Total Amount</th>
            {/* <th className="text-center">Outstanding</th> */}
            <th className="text-center" style={{ width: "5%" }}>
              
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {taxinvoiceList?.length > 0 ? (
            taxinvoiceList.map((data) => (
              <tr>
                <td>{data.application_no}</td>
                <td>{data.taxinvoice_no}</td>
                <td>{data.applicant_name}</td>
                <td>{data.company}</td>
                <td className="text-center">{data.taxinvoice_date != null ? moment(data.taxinvoice_date).format("DD-MM-YYYY") : ""}</td>
                <td className="text-right">{data.taxable_amt != null ? data.taxable_amt.toLocaleString() : ''}</td>
                <td className="text-right">{data.cgst != null ? data.cgst.toLocaleString() : ''}</td>
                <td className="text-right">{data.sgst != null ? data.sgst.toLocaleString() : ''}</td>
                <td className="text-right">{data.igst != null ? data.igst.toLocaleString() : ''}</td>
                <td className="text-right">{data.grand_total != null ? data.grand_total.toLocaleString() : ''}</td>
                {/* <td className="text-right">{data.outstanding != null ? data.outstanding.toLocaleString() : ''}</td> */}
                {/* <td>{data.taxinvoiceInvoiceNo}</td> */}
                {/* <td>{data.is_active ? "Active" : "Inactive"}</td> */}

                <td className="text-center">
                  <img src="img/pdf-icon.png" height={20} width={18}
                    title="view"
                    className="btn btn-sm"
                    onClick={() => this.viewtaxinvoice(data.application_form_id, data.taxinvoice_id)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <td colSpan={12} className="text-center">
              No records found
            </td>
          )}
        </tbody>
      </table>
    );
  }
  render() {
    const {
      isLoading,
      taxinvoiceList,
      currentPage,
      isAccordionExpanded,
      ApplicantName,
      taxinvoiceDate,
      taxinvoiceInvoiceNo,
      Experience,
      taxinvoice_id,
      application_no
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = taxinvoiceList?.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(taxinvoiceList?.length / recordsPerPage);

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            
                        <div className="website-view">
                          <Header data={[8]} />
                        </div>
                        <div className="mobile-view">
                          <MobileHeader data={[8]} />
                        </div>
            <section class='header_margin_top'>
              <div className="container-fluid">
                <div className="page-header">
                <h2 class="mb-3 dashboard-tit  py-0 blog-name blog-name-1"> Tax Invoice List</h2>
                  {/* <div onClick={() => this.navigatetaxinvoiceAdd()}>
                        <i class="ri-add-box-line" style={{fontSize:"28px",cursor:'pointer'}}></i>
                    </div> */}
                </div>
                {role_id != 4 &&
                  <div className="search_accordion search_card">
                    <div className="panel-group" id="accordion">
                      <div className="panel panel-default">
                        <div
                          className="panel-heading accordion-toggle collapsed"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          data-target="#collapseOne"
                          aria-expanded={isAccordionExpanded}
                          onClick={() =>
                            this.setState({
                              isAccordionExpanded: !isAccordionExpanded,
                            })
                          }
                        >
                          <h4 className="panel-title">Search</h4>
                          <div className="searched_items">
                            {taxinvoiceInvoiceNo ? <>
                              <h5>
                                <b> Tax Invoice No :</b> <span>{taxinvoiceInvoiceNo}</span>
                              </h5>
                            </> : <></>}
                            {ApplicantName ? <>
                              <h5>
                                <b>Applicant Name :</b> <span>{ApplicantName}</span>
                              </h5>
                            </> : <></>}
                            {taxinvoiceDate ? <>
                              <h5>
                                <b>Tax Invoice Date :</b>  <span>{taxinvoiceDate != '' ? moment(taxinvoiceDate).format('DD-MM-YYYY') : ''}</span>
                              </h5>
                            </> : <></>}
                            {/* {Experience ? <>
                                <h5>
                                  <b>Experience :</b> <span>{Experience}</span>
                                </h5>
                              </> : <></>} */}
                          </div>
                        </div>
                        <div
                          id="collapseOne"
                          className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                            }`}
                        >
                          <div className="panel-body">
                            <div className="row mr_0 ml-1">
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Application No</label>
                                  <input
                                    type="text"
                                    className="form-control search_form_control"
                                    // placeholder="Enter application no"
                                    value={application_no}
                                    onChange={(e) =>
                                      this.setState({ application_no: e.target.value.replace(/\D/, '') })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Tax Invoice No</label>
                                  <input
                                    type="text"
                                    className="form-control search_form_control"
                                    // placeholder="Enter taxinvoiceInvoice No"
                                    value={taxinvoiceInvoiceNo}
                                    onChange={(e) =>
                                      this.setState({ taxinvoiceInvoiceNo: e.target.value })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Applicant Name</label>
                                  <input
                                    type="text"
                                    className="form-control search_form_control"
                                    // placeholder="Enter Name"
                                    value={ApplicantName}
                                    onChange={(e) =>
                                      this.setState({ ApplicantName: e.target.value })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Tax Invoice Date</label>
                                  <DatePicker className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                    selected={taxinvoiceDate}
                                    onChange={(date) => {
                                      this.setState({ taxinvoiceDate: date ? moment.utc(date).toDate() : '' })
                                    }}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="DD/MM/YYYY"
                                  /> <div style={{ zIndex: '99' }} className="form-group d-flex" >
                                  </div>
                                </div>
                              </div>
                              {/* <div className="col-md-2">
                                  <div className="form-group">
                                    <label>Experience</label>
                                    <input
                                      type="text"
                                      className="form-control search_form_control"
                                      placeholder="Enter Experience"
                                      value={Experience}
                                      onChange={(e) =>
                                        this.setState({
                                          Experience: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div> */}

                              <div className="col-md-4">
                                <label>&nbsp;</label>
                                <button onClick={() => this.getTaxinvoiceList()} className="btn btn-primary search_btn">Search</button>
                                &nbsp;
                                <button onClick={this.clearFilters} className="btn btn-primary clr_btn">Clear Filters</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}
                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.taxinvoiceRecords(currentRecords)}
                      {taxinvoiceList?.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <ToastContainer />
        </>
      </>
    );
  }
}
const mapDispatchToProps = { get_taxinvoiceList_action, download_taxinvoice_action };

export default withRouter(
  connect(null, mapDispatchToProps)(TaxInvoiceList)
);


